import { screen } from './'

export const buildEventScreenSignIn = () => {
  screen.openSignIn()
}
